exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-465be7f0]{font-size:20px;font-weight:bold}.type_button[data-v-465be7f0]{width:80px;height:30px;background:#fff;margin-right:10px;font-size:14px;border-radius:6px}.selector_button[data-v-465be7f0]{font-weight:600;background:#409eff;color:#fff}", ""]);

// exports
